/** One ref callback for an element two things attach to: a row that sorts and a target that takes a drop. */
export function mergeRefs(
  ...refs: ((element: Element | null) => void)[]
): (element: Element | null) => void {
  return (element) => {
    for (const ref of refs) ref(element);
  };
}
